import React, { useEffect, useState } from 'react';
import { styles } from "./styles";
import { Grid, Button, Box, LinearProgress, Typography, TextField, Icon, IconButton } from "@mui/material";
import DataMuiSelect from 'components/MuiSelect/DataMuiSelect';
import { styles as inputStyles } from "common/inputStyles";
import DeviceEventTableHeader from 'components/TableHeader/DeviceEventTableHeader';
import ReportDataTable from 'components/DataTable/ReportDataTable';
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';
import { getAllDevices, getAllServiceProviders, getSegment, getAllDeviceTypes, getAllFailedDeviceEvents } from 'apis/device';
import moment from "moment";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import CommonUtil from 'common/CommonUtil';
import ErrorPopup from 'common/ErrorPopup';

LicenseManager.setLicenseKey("CompanyName=Rehrig Pacific Company (Richardson, TX),LicensedApplication=Rehrig Vision,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-037353,SupportServicesEnd=29_December_2024_[v2]_MTczNTQzMDQwMDAwMA==2cc2796737bee66cd2e64e46b6c5759c")

interface DeviceEventsReportProps {
}

var pgNumber = 0;
var records: any = [];
const DeviceEventsReport: React.FC<DeviceEventsReportProps> = () => {
  const [searchVal, setSearchVal] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [deviceData, setDeviceData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [err, setErr] = useState("");
  const [showCont, setShowCont] = useState(false);
  const [deviceId, setDeviceId] = useState("");
  const [serviceProvider, setServiceProvider] = useState<any>(null);
  const [isServiceProviderError, setServiceProviderError] = useState(false);
  const [providers, setProviders] = useState([]);
  const [segments, setSegments] = useState([]);
  const [currSegment, setCurrSegment] = useState<any>(null);
  const [truckId, setTruckId] = useState("");
  const [types, setTypes] = useState<any>([]);
  const [events, setEvents] = useState<any>(null);
  const [isEventError, setEventError] = useState(false);
  const [eventsData, setEventsData] = useState<any>(CommonUtil.events);
  const [deviceTypeName, setDeviceTypeName] = useState<any>("");
  const [fromvalue, setFromvalue] = React.useState<Dayjs | null>(dayjs(new Date()));
  const [tovalue, settovalue] = React.useState<Dayjs | null>(dayjs(new Date()));
  const [fromDate, setFromDate] = useState<any>('');
  const [isFromDateError, setFromDateError] = useState(false);
  const [toDate, setToDate] = useState<any>('');
  const [isToDateError, setToDateError] = useState(false);
  const [showErrorPopup,setShowErrorPopup] = useState(false);
  const [checkedData, setCheckedData] = useState<any>(null);
  const [formattedData, setFormattedData] = useState<any>(null);
  const [deviceReportAfterFilter, setDeviceReportAfterFilter] = useState([]);

  function showdataError() {
    setShowModal(true);
    setErr("No data available");
    setTimeout(() => {
      setDeviceData([]);
      localStorage.removeItem('fromDate');
      localStorage.removeItem('toDate');
      setShowModal(false);
    }, 2000);
  }
  function showdataErrorWithReload() {
    setShowModal(true);
    setErr("No data available");
    setTimeout(() => {
      localStorage.removeItem('fromDate');
      localStorage.removeItem('toDate');
      setShowModal(false);
      window.location.reload();
    }, 2000);
  }

  const getAllDeviceevents = async () => {
      let dId = deviceId;
      let eType = (events) ? events.value : "";
      let segId = currSegment ? currSegment.id : "";
      let spId = serviceProvider ? serviceProvider.id : "";
      setDeviceData([]);
      records = [];
      pgNumber = 1;
      let data = await getAllFailedDeviceEvents(dId, eType, segId, spId, truckId, pgNumber);
      if (data) {
        records = records.concat(data.records);
        if(data.hasMore){
          while(true){
            pgNumber = pgNumber + 1;
            data = await getAllFailedDeviceEvents(dId, eType, segId, spId, truckId, pgNumber);
            if(data){
                records = records.concat(data.records);
            }
            if(records.length>=CommonUtil.RECORD_COUNT){
              setShowErrorPopup(true);
              break;
            }
            if(!data.hasMore){
              break;
            }
          }
        }else{

        }
        const sortedArray = records.sort((a: any, b: any) => {
          const dateA = new Date(a.eventTimestampMillis);
          const dateB = new Date(b.eventTimestampMillis);
          if (dateA > dateB) {
            return -1;
          } else if (dateA < dateB) {
            return 1;
          } else {
            return 0;
          }
        });
        if(sortedArray && sortedArray[0]) {
        let newArr = sortedArray.filter((s: any) => s.creationDate !== null);
        setDeviceData(sortedArray);
        }
      }
      else {
        pgNumber = 0;
        showdataError();
        setDeviceData([]);
        setIsLoading(false);
      }
  }

  const getServiceProviders = async () => {
    let data = await getAllServiceProviders();
    console.log(data);
    if (data?.response?.data?.errorMessage) {
      return
    }
    if (data && data[0]) {
      setProviders(data);
    }
  }
  const getSegmentList = async (id: string) => {
    let data = await getSegment(id);

    if (data?.response?.data?.error) {
      console.log('error');
      return
    }
    if (data) {
      setSegments(data);
    }
  }
  const getDeviceTypes = async () => {
    let data = await getAllDeviceTypes();
    console.log(data);
    if (data?.response?.data?.errorMessage) {
      console.log('error');
      return
    }
    if (data && data[0]) {
      setTypes(data);

    }
  }

  useEffect(() => {
    pgNumber = 0;
    records = [];
    getServiceProviders();
    getDeviceTypes();
  }, [])

  const onChangeServiceProvider = (data: any) => {
    setServiceProvider(data);
    setServiceProviderError(!data || data.length === 0);
    setSegments([]);
    setCurrSegment(null);
    if (data) {
      console.log(data.id);
      getSegmentList(data.id)
    }
  }

  const onChangeCurrSegmentHandler = (data: any) => {
    setCurrSegment(data);
    console.log(data.id);
    // localStorage.setItem('segmentID', data.id);
  }

  const ChangeEventsHandler = (data: any) => {
    setEvents(data);
    setEventError(!data || data.length === 0);
  }

  const getDateValeus = () => {
    localStorage.removeItem('fromDate');
    localStorage.removeItem('toDate');
    let date: any = fromvalue?.get('date');
    let month: any = fromvalue?.get('month');
    let year: any = fromvalue?.get('year');

    let newMonth = month < 9 ? `0${month + 1}` : `${month + 1}`; //adding 0 to month if single digit

    let newdate = date < 10 ? `0${date}` : `${date}`; //adding 0 to date if single digit

    let fDate: any = `${newMonth}-${newdate}-${year}`;
    //console.log(fromDate);

    // getting value from toDate
    let tdate: any = tovalue?.get('date');
    let tmonth: any = tovalue?.get('month');
    let tyear: any = tovalue?.get('year');

    let tnewMonth = tmonth < 9 ? `0${tmonth + 1}` : `${tmonth + 1}`; //adding 0 to month if it is single digit

    let tnewdate = tdate < 10 ? `0${tdate}` : `${tdate}`; //adding 0 to date if it is single digit

    var tDate: any = `${tnewMonth}-${tnewdate}-${tyear}`;

    // console.log(fromDate, toDate);
    setFromDate(fDate);
    setToDate(tDate);
    localStorage.setItem('fromDate', fDate);
    localStorage.setItem('toDate', tDate);
  }

  useEffect(() => {
    setFromDate(fromvalue);
    setToDate(tovalue);
  }, [])

  const getDeviceEvents = () => {
    if(isServiceProviderError || isEventError || isFromDateError || isToDateError) {
     return false;
    }
    if(!serviceProvider || serviceProvider.length === 0) {
      setServiceProviderError(!serviceProvider || serviceProvider.length === 0);
      return false;
    }
    if(!events || events.length === 0) {
      setEventError(!events || events.length === 0);
      return false;
    }
    if(!fromvalue || !fromvalue.isValid()) {
      setFromDateError(!isFromDateError);
      return false;
    }
    if(!tovalue || !tovalue.isValid()) {
      setToDateError(!isToDateError);
      return false;
    }
    let hours = tovalue.diff(fromvalue, 'hours');
    const days = Math.floor(hours / 24);
    if(days > 6) {
      alert("Date range should not exceed 7 days.");
      return false;
    }
    if(days < 0) {
      alert("Invalid date range.")
      return false;
    }
    setFormattedData("");
    setCheckedData("");
    getDateValeus();
    getAllDeviceevents();
  }

  const closeErrorPopup = ()=>{
    setShowErrorPopup(false);
  }

     // Downloading Only Filtered Data After Search
     const updateFilteredData = (data:[]) => {
      setDeviceReportAfterFilter(data);
    }

  return (
    <Grid container spacing={2}>
      {isLoading && <LinearProgress />}
      {showModal ? (err !== "" && <Typography sx={styles.errContainer}>{err}</Typography>) : ""}
      {showErrorPopup?<ErrorPopup title='Data' popupText='10000 records loaded from available data' open={showErrorPopup} handlePopupClose={closeErrorPopup}></ErrorPopup>:""}
      <Grid container spacing={2} style={{ width: '100%', marginTop: '5px', padding: '15px' }}>
        <Grid item xs={3} sx={{ marginBottom: "15px", marginTop: "0px" }}>
          <DataMuiSelect label={"Service Provider"} sKey={"id"} value={"name"} selectedValue={serviceProvider} dataSource={providers}
            onChangeHandler={(e: any) => onChangeServiceProvider(e)} mandatory={true} isError={isServiceProviderError} errorText={"Required Field."}/>
        </Grid>
        <Grid item xs={3} sx={{ marginBottom: "15px" }}>
          <DataMuiSelect label={"Segment"} sKey={"id"} value={"name"} selectedValue={currSegment} dataSource={segments}
            onChangeHandler={(e: any) => onChangeCurrSegmentHandler(e)} />
        </Grid>
        <Grid item xs={3} sx={{ marginBottom: "15px" }}>
          <TextField style={{ width: "100%", paddingBottom: "0px" }} label={"Device ID"} value={deviceId}
            onChange={(e) => setDeviceId(e.target.value)} />
        </Grid>
        <Grid item xs={3} sx={{ marginBottom: "15px" }}>
          <TextField style={{ width: "100%", paddingBottom: "0px" }} label={"Truck Number"} value={truckId}
            onChange={(e) => setTruckId(e.target.value)} />
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ width: '100%', padding: '0px 15px' }}>
        <Grid item xs={3} sx={{ marginBottom: "15px", marginTop: '0px' }}>
          <DataMuiSelect label={"Event"} sKey={"key"} value={"value"} selectedValue={events} dataSource={eventsData}
            onChangeHandler={(e: any) => ChangeEventsHandler(e)} mandatory={true} isError={isEventError} errorText={"Required Field."}/>
        </Grid>
        <Grid item xs={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="From"
              openTo="day"
              views={['year', 'month', 'day']}
              value={fromvalue}
              inputFormat="MM-DD-YYYY"
              onChange={(newValue) => {
                setFromvalue(newValue);
                setFromDateError(!newValue  || !newValue.isValid());
                setServiceProviderError(!serviceProvider || serviceProvider.length === 0);
                setEventError(!events || events.length === 0);
              }}
              renderInput={(params) => <TextField  {...params} required={true} style={{ width: "100%" }} 
              error={isFromDateError || !fromvalue || !fromvalue.isValid()}
              helperText={isFromDateError ? ( !fromvalue ? "Requried Field.": "Invalid Date."):""}
              />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid xs={3} sx={{ marginTop: "15px", paddingLeft: '15px' }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="To"
              openTo="day"
              views={['year', 'month', 'day']}
              value={tovalue}
              // onChange={handletoDateChange}
              inputFormat="MM-DD-YYYY"
              onChange={(newValue) => {
                settovalue(newValue);
                setToDateError(!newValue || !newValue.isValid());
                setServiceProviderError(!serviceProvider || serviceProvider.length === 0);
                setEventError(!events || events.length === 0);
              }}
              renderInput={(params) => <TextField {...params} required={true} style={{ marginBottom: "15px", width: "100%" }} 
              error={isToDateError || !tovalue || !tovalue.isValid() }
              helperText={isToDateError ? ( !tovalue? "Requried Field.": "Invalid Date."):""}
              />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid xs={3} sx={{ paddingTop: "18px", paddingLeft: '15px' }}>
          <Button sx={inputStyles.buttonGreen} onClick={getDeviceEvents}>Search</Button>
        </Grid>
      </Grid>

      <DeviceEventTableHeader searchVal={searchVal} setSearchVal={setSearchVal} setShowCont={setShowCont} setFormattedData={setFormattedData} formattedData={formattedData} checkedData={checkedData} setCheckedData={setCheckedData} data={deviceReportAfterFilter} csvLabel={"DeviceEventsReport.csv"} />
      <Grid item xs={12} sx={{ height: "80vh" }}>
         {/* Added Filtered data Download after Search (getFilteredData={updateFilteredData} ) */}
        <ReportDataTable data={deviceData} searchVal={searchVal} getFilteredData={updateFilteredData} />
      </Grid>
    </Grid>
  )
}

export default DeviceEventsReport;
